import ModalPresentation from 'components/Modal/ModalPresentation'

export default {
  Presentation: ModalPresentation,
}
